// Le type d'une image base64 se lit dans ses premiers caractères : Odoo rend
// l'avatar par défaut en SVG, une photo posée en JPEG ou en PNG, et un
// navigateur n'affiche pas un SVG déclaré comme PNG. Partagé par l'écran du
// salarié et la fiche vue par la RH.
export const typeImage = (base64) => {
  if (base64.startsWith('/9j/')) return 'image/jpeg';
  if (base64.startsWith('PD94bW') || base64.startsWith('PHN2Zy')) return 'image/svg+xml';
  return 'image/png';
};

// Une photo posée est une image PNG ou JPEG : seuls ces formats se téléversent.
// L'avatar SVG par défaut d'Odoo n'en est pas une.
export const estPhotoPosee = (photo) => Boolean(photo) && typeImage(photo) !== 'image/svg+xml';
